/**
 * Frontend analytics stub — App Insights removed; GA4 handled separately.
 * Keeps the same API surface for callers (logger, api.client, buttons, etc.).
 */

class FrontendAnalyticsService {
  private hasUserConsent = true;

  initialize(_instrumentationKey: string): void {
    // No-op: telemetry is optional; use Google Analytics when configured.
  }

  setUser(_userId: string, _accountId?: string, _email?: string): void {}

  clearUser(): void {}

  /**
   * Stable per-page-load correlation ID (UUID) so API `extractCorrelationId`
   * preserves browser → Worker log joins.
   */
  private operationId: string | null = null;

  getOperationId(): string {
    if (this.operationId) return this.operationId;
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      this.operationId = crypto.randomUUID();
    } else {
      // RFC4122-ish fallback when crypto.randomUUID is unavailable (rare)
      this.operationId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (ch) => {
        const r = (Math.random() * 16) | 0;
        const v = ch === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    }
    return this.operationId;
  }

  setConsent(consented: boolean): void {
    this.hasUserConsent = consented;
    localStorage.setItem('analytics_consent', consented.toString());
  }

  getConsent(): boolean {
    const stored = localStorage.getItem('analytics_consent');
    if (stored !== null) {
      this.hasUserConsent = stored === 'true';
    }
    return this.hasUserConsent;
  }

  trackPageView(_name: string, _url?: string, _properties?: Record<string, unknown>): void {}

  trackEvent(_name: string, _properties?: Record<string, unknown>): void {}

  trackException(
    _error: Error,
    _properties?: Record<string, unknown>,
    _severityLevel?: number
  ): void {}

  trackMetric(_name: string, _value: number, _properties?: Record<string, unknown>): void {}

  trackDependency(
    _name: string,
    _duration: number,
    _success: boolean,
    _properties?: Record<string, unknown>
  ): void {}
}

export const analyticsService = new FrontendAnalyticsService();
